import React, { useEffect, useState } from "react";
import { bool, arrayOf, shape } from "prop-types";
import { connect, useDispatch } from "react-redux";
import MainContainer from "pages/_components/MainContainer";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Button from "pages/_components/Button";
import MaskedTextField from "pages/_components/fields/MaskedTextField";
import * as maskUtils from "util/mask";

import { actions as onboardingActions, selectors as onboardingSelectors } from "reducers/onboarding";
import { actions as modalActions } from "reducers/modal";
import * as i18nUtils from "util/i18n";
import { goBack, push } from "connected-react-router";

import { ResponsiveHeader } from "pages/_components/header";
import CustomText from "pages/_components/CustomText/CustomText";
import ErrorPopup from "../_components/ErrorPopup";

const FORM_ID = "onboarding.step.invitationCode";

const StepInvitationCode = ({
    isMobile,
    invitationCodeRequest,
    signerUserExists,
    isUserMigrated,
    isMultiEnvironment,
    redirectStepUser,
}) => {
    const dispatch = useDispatch();
    const {
        status: invitationCodeRequestStatus,
        // value: invitationCodeRequestValue,
        error: invitationCodeRequestError,
    } = invitationCodeRequest;
    const [error, setError] = useState("");

    useEffect(() => {
        if (invitationCodeRequestStatus === "SUCCESS") {
            dispatch(onboardingActions.setOnboardingWithInvitation(true));
            dispatch(onboardingActions.resetInvitationCodeRequest());

            /* Si en la verificacion del codigo se detecto que el firmante ya tiene usuario asociado
                debe validar sus credenciales, sino se continua con el proceso de onboarding del nuevo usuario
            */
            if (isUserMigrated) {
                if (isMultiEnvironment) {
                    dispatch(push("/migration/stepVerifyUsername"));
                } else if (redirectStepUser) {
                    dispatch(push("/migration/stepUser"));
                } else {
                    dispatch(push("/migration/stepSms"));
                }
            } else if (signerUserExists) {
                dispatch(push("/onboarding/StepVerifyUsername"));
            } else {
                dispatch(push("/onboarding/stepStart"));
            }
        } else if (invitationCodeRequestStatus === "FAILURE") {
            setError(invitationCodeRequestError);
            dispatch(modalActions.modalShow());
        }
    }, [invitationCodeRequestStatus, invitationCodeRequestError]);

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const formikProps = {
        validateOnChange: false,
        validateOnBlur: true,
        initialValues: {
            _code: "",
        },
        validationSchema: () =>
            Yup.object().shape({
                _code: Yup.string()
                    .required(i18nUtils.get("forms.inputFile.massivePayments.invalid.required"))
                    .test(
                        "invitationCode-format",
                        i18nUtils.get("", "El código es invalido"),
                        (value) => /\d/.test(value) && value.length === 14,
                    ),
            }),
        onSubmit: ({ _code }) => {
            dispatch(onboardingActions.verifyOnbInvitationCode(_code));
        },
    };

    const handleClickButtonClose = () => {
        dispatch(modalActions.modalClose());
    };

    // const codeFormatFunction = (newValue) => {
    //     if (newValue.length === 4 || newValue.length === 9) {
    //         return `${newValue}-`;
    //     }

    //     if (newValue.length === 5 || newValue.length === 10) {
    //         return newValue.slice(0, -1);
    //     }

    //     return newValue;
    // };

    return (
        <>
            {isMobile && <ResponsiveHeader id="onboarding.noUser.title" onClickBack={onHeaderBack} showCenterContent />}
            <MainContainer>
                <Formik {...formikProps}>
                    {(allFormik) => (
                        <Form className="above-the-fold">
                            <h1>
                                <CustomText
                                    textType="TEXT"
                                    keepSpaceIfNoText
                                    text={i18nUtils.get("", "Código de invitación")}
                                />
                            </h1>
                            <CustomText
                                text={i18nUtils.get(
                                    "",
                                    "Ingresá el código de 12 digitos que te enviamos en tu correo eléctronico.",
                                )}
                            />

                            <Field
                                autoComplete="off"
                                component={MaskedTextField}
                                mask={maskUtils.invitationCodeMask()}
                                idForm={FORM_ID}
                                maxLength={14}
                                name="_code"
                                autoFocus={!isMobile}
                                hidePlaceholder
                                handleOnChange={() => allFormik.setErrors({})}
                                labelTextDefault="Código de invitación"
                                variant="standard"
                            />

                            <div className="form-actions">
                                <Button
                                    bsStyle="primary"
                                    label="global.continue"
                                    type="submit"
                                    block
                                    disabled={
                                        !(allFormik.isValid && allFormik.dirty && allFormik.values._code.length === 14)
                                    }
                                    loading={allFormik.isSubmitting && invitationCodeRequestStatus === "FETCHING"}
                                />
                            </div>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
            <ErrorPopup error={error} handleClick={handleClickButtonClose} />
        </>
    );
};

StepInvitationCode.defaultProps = {
    isUserMigrated: false,
    isMultiEnvironment: false,
    redirectStepUser: false,
};

StepInvitationCode.propTypes = {
    isMobile: bool.isRequired,
    invitationCodeRequest: arrayOf(shape({})).isRequired,
    signerUserExists: bool.isRequired,
    isUserMigrated: bool,
    isMultiEnvironment: bool,
    redirectStepUser: bool,
};

const mapStateToProps = (state) => ({
    invitationCodeRequest: onboardingSelectors.getInvitationCodeRequest(state),
    signerUserExists: onboardingSelectors.getSignerUserExists(state),
    isUserMigrated: onboardingSelectors.getIsUserMigrated(state),
    isMultiEnvironment: onboardingSelectors.getIsMultiEnvironment(state),
    redirectStepUser: onboardingSelectors.getRedirectStepUser(state),
});

export default connect(mapStateToProps)(StepInvitationCode);
